import { Base_Contract } from '@coder-pioneers/shared';

export class ChangePassword extends Base_Contract {
  newPassword:     string | undefined;
  confirmPassword: string | undefined;


}






























